import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import { getClickButton } from "../../../../functions/getButtons";
import { emptySecret, ISecret } from "./QmlativIntegrationAccessDialog";

interface IShowSecretDialog {
  showSecret: boolean;
  setShowSecret: (val: boolean) => void;
  secret: ISecret;
  setSecret: (val: ISecret) => void;
}

const ShowSecretDialog = (props: IShowSecretDialog) => {
  const { showSecret, setShowSecret, secret, setSecret } = props;

  const closeSecretDialog = () => {
    setSecret(emptySecret);
    setShowSecret(false);
  };

  return (
    <Dialog open={showSecret} maxWidth="lg" onClose={closeSecretDialog} area-labelledby="qmlativ-secret-dialog-title">
      <DialogTitle>Secret for {secret.envName}</DialogTitle>
      <DialogContent>
        <DialogContentText>This secret will be shown this time only. Copy it and save it in a secure location.</DialogContentText>
        <DialogContentText>Key: {secret.envKey}</DialogContentText>
        <DialogContentText>Secret: {secret.secret}</DialogContentText>
      </DialogContent>
      <DialogActions>{getClickButton("Close", <Close />, () => setShowSecret(false))}</DialogActions>
    </Dialog>
  );
};

export default ShowSecretDialog;
